<template>
  <div>
    <vxe-grid
      ref="fabricTable"
      auto-resize
      resizable
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :height="347"
      border
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :edit-config="{ trigger: 'click', mode: 'row', enabled: !disabled }"
      @edit-closed="onEditClosed"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form>
        <div class="d-flex">
          <div class="side-frame-success"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ 'TC面料采购单明细' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="fabricOptionalVisible = true"
              v-if="!disabled"
            >
              <i class="el-icon-plus" />
              {{ $l('INDEX.btn_add') || '添加' }}
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:opt="{ row, rowIndex }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del({ ...row, index: rowIndex })"
          ></i>
        </el-tooltip>
      </template>
    </vxe-grid>

    <FabricOptional
      :title="'选择面料明细'"
      :visible.sync="fabricOptionalVisible"
      :orderCode="orderCode"
      @confirm="fabricOptionalConfirm"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { add, multiply } from '@/libs/util.number.js'
import FabricOptional from '../fabric-optional'
export default {
  mixins: [TableAutoHeight],
  components: { FabricOptional },
  props: {
    tableData: { type: Array, default: () => [] },
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      v_tableData: [],
      fabricOptionalVisible: false,
      tableColumns: tableColumns(this),
      editRules: {
        qty: [
          { required: true, message: '请输入数量' },
          { type: 'number', min: 1, message: '数量最少为1' },
        ],
        fabricUnit: [{ required: true, message: '请选择面料单位' }],
        unitPrice: [
          { required: true, message: '请输入单价' },
          { type: 'number', min: 0.1, message: '请输入正确的单价' },
        ],
      },
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  methods: {
    onEditClosed({ row }) {
      if (this.disabled) return
      row.subAmount = multiply(row.unitPrice, row.qty)
      row.v_subAmount = row.subAmount.toLocaleString()
      this.subAmountChange()
    },
    subAmountChange() {
      const tableData = this.getTableData()
      const totalAmount = tableData.reduce(
        (result, next) => add(result, next['subAmount']),
        0
      )
      this.$emit('totalAmountChange', totalAmount)
    },
    async validate() {
      const result = await this.$refs.fabricTable.validate(true)
      return !result
    },
    getTableData() {
      const { fullData: tableData } = this.$refs.fabricTable.getTableData()
      return tableData || []
    },
    del({ index }) {
      this.v_tableData.splice(index, 1)
    },
    fabricOptionalConfirm(e) {
      if (!e || !e.length) return
      if (!this.v_tableData || !this.v_tableData.length) {
        this.v_tableData.push(...e)
        this.subAmountChange()
        return
      }
      for (let item of e) {
        const index = this.v_tableData.findIndex((i) => {
          return (
            i.fabricNo === item.fabricNo &&
            i.fabricName === item.fabricName &&
            i.fabricColor === item.fabricColor &&
            i.fabricWeight === item.fabricWeight
          )
        })
        if (index < 0) {
          this.v_tableData.push({ ...item, qty: 1 })
          continue
        }
        const qty = (this.v_tableData[index].qty || 0) + 1
        const unitPrice = this.v_tableData[index].unitPrice
        this.v_tableData[index].qty = qty
        const subAmount = multiply(unitPrice, qty)
        this.v_tableData[index].subAmount = subAmount
        this.v_tableData[index].v_subAmount = subAmount.toLocaleString()
      }
      this.subAmountChange()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
